"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = exports.Icon = exports.Content = exports.Body = exports.Disclaimer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getBackground = function getBackground(_ref) {
  var variant = _ref.variant,
      color = _ref.color;
  return {
    alert: color.feedback.alert,
    success: color.feedback.success,
    error: color.feedback.error
  }[variant] || color.brandPrimary.dark;
};

var Disclaimer = _styledComponents["default"].div.withConfig({
  displayName: "Disclaimerstyle__Disclaimer",
  componentId: "sc-1e5uoxh-0"
})(function (_ref2) {
  var variant = _ref2.variant,
      _ref2$theme = _ref2.theme,
      spacing = _ref2$theme.spacing,
      color = _ref2$theme.color,
      breakpoint = _ref2$theme.breakpoint;
  return _defineProperty({
    background: getBackground({
      variant: variant,
      color: color
    }),
    boxSizing: 'border-box',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: "".concat(spacing.inline['3xs'], " 0 ").concat(spacing.inline['3xs'], " ").concat(spacing.inline['3xs'])
  }, breakpoint.lg(), {
    padding: "".concat(spacing.inline.xs, " 0 ").concat(spacing.inline.xs, " ").concat(spacing.inline.md)
  });
});

exports.Disclaimer = Disclaimer;

var Body = _styledComponents["default"].div.withConfig({
  displayName: "Disclaimerstyle__Body",
  componentId: "sc-1e5uoxh-1"
})(function (_ref4) {
  var breakpoint = _ref4.theme.breakpoint;
  return _defineProperty({
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  }, breakpoint.lg(), {
    flexDirection: 'row',
    alignItems: 'center'
  });
});

exports.Body = Body;

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Disclaimerstyle__Content",
  componentId: "sc-1e5uoxh-2"
})({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flex: 'auto'
});

exports.Content = Content;

var Icon = _styledComponents["default"].div.withConfig({
  displayName: "Disclaimerstyle__Icon",
  componentId: "sc-1e5uoxh-3"
})(function (_ref6) {
  var _ref6$theme = _ref6.theme,
      spacing = _ref6$theme.spacing,
      color = _ref6$theme.color,
      breakpoint = _ref6$theme.breakpoint;
  return _defineProperty({
    marginRight: spacing.inline['4xs'],
    svg: {
      fill: color.neutral['08'],
      width: spacing.inline.md,
      height: spacing.inline.md
    }
  }, breakpoint.lg(), {
    marginRight: spacing.inline['3xs'],
    svg: {
      width: spacing.inline['2xl'],
      height: spacing.inline['2xl']
    }
  });
});

exports.Icon = Icon;

var Actions = _styledComponents["default"].div.withConfig({
  displayName: "Disclaimerstyle__Actions",
  componentId: "sc-1e5uoxh-4"
})(function (_ref8) {
  var _ref8$theme = _ref8.theme,
      spacing = _ref8$theme.spacing,
      breakpoint = _ref8$theme.breakpoint;
  return _defineProperty({
    '> *': {
      marginTop: spacing.inline['3xs'],
      marginRight: spacing.inline['3xs']
    }
  }, breakpoint.lg(), {
    flex: '0 0 auto',
    marginRight: spacing.inline['3xs'],
    '> *': {
      marginTop: 0,
      marginRight: 0,
      marginLeft: spacing.inline['3xs']
    }
  });
});

exports.Actions = Actions;